import React from 'react';
import relationships from 'Consts/Relationships';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import moment from 'moment';
import { fullDateTime } from 'Consts/DateFormats';
import { getApexACHRelationshipTransferStatusColor, getApexACHRelationshipTransferTypeColor } from 'Consts/Apex';
import { currency } from 'Helpers/Formats';
import { refreshAchRelationshipResource } from 'Components/AdvisorApp/Viewport/ApexAdminPortal/ApexAdminPortalActions';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { useApexAdminPortalStateContext, useApexAdminPortalDispatchContext } from '../../ApexAdminPortalContext';
import View from './View';

const EMPTY_MODAL_STATE = {
  url: '',
  show: false,
  onClose: () => {},
};
const createModalState = (url, show, onClose) => { return { url, show, onClose }; };

const Transfers = () => {
  const { achRelationshipResource } = useApexAdminPortalStateContext();
  const apexDispatch = useApexAdminPortalDispatchContext();
  const [transfersCollection, setTransfersCollection] = React.useState(null);
  const [rows, setRows] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [modalState, setModalState] = React.useState(EMPTY_MODAL_STATE);
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Transfers' });

  const refreshCollection = async () => {
    try {
      setIsLoading(true);
      const newCollection = await achRelationshipResource?.relationship(relationships.achTransfers)?.link('related').Get();
      setTransfersCollection(newCollection);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setIsLoading(false);
    }
  };

  const refreshRows = () => {
    const newRows = transfersCollection?.resources()?.list().map((transferResource) => {
      let statusPrompt = transferResource.meta().field('status').option(transferResource.attr('status')).attr('prompt');
      if (statusPrompt?.includes('Rejected')) {
        statusPrompt = 'Rejected';
      }

      return {
        statusColors: getApexACHRelationshipTransferStatusColor(transferResource.attr('status')),
        transferColors: getApexACHRelationshipTransferTypeColor(transferResource.attr('type')),
        status: statusPrompt,
        transferType: transferResource.meta().field('type').option(transferResource.attr('type')).attr('prompt'),
        transferDate: moment(transferResource.attr('transferDate')).utc().format(fullDateTime),
        amount: currency(transferResource.attr('amount')),
        onClick: () => {
          setModalState(createModalState(
            transferResource.link('self').url(),
            true,
            () => {
              setModalState(EMPTY_MODAL_STATE);
              refreshAchRelationshipResource(achRelationshipResource, apexDispatch)
                .catch(err => displayErrorMessage(err, err.errors));
            },
          ));
          logEvent('Click Transfer Status');
        },
      };
    });

    setRows(newRows);
  };

  React.useEffect(() => {
    refreshCollection();
  }, [achRelationshipResource]);
  React.useEffect(() => {
    if (transfersCollection) {
      refreshRows();
    }
  }, [transfersCollection]);

  if (!achRelationshipResource) {
    return null;
  }

  return (
    <View
      rows={rows}
      isLoading={isLoading}
      modalState={modalState}
      amplitudeRootNodeProps={rootNodeProps}
    />
  );
};

export default Transfers;
